import { WorkflowTemplateRestoreVersionDetails } from "store/workflowTemplates";
import { getObject, remove, RepositoryKey, setObject } from "utils/repository";

export function getWorkflowTemplateRestoreVersionDetails(): WorkflowTemplateRestoreVersionDetails | null {
    const workflow: WorkflowTemplateRestoreVersionDetails | null = getObject(
        RepositoryKey.WORKFLOW_TEMPLATE_RESTORE_VERSION_DETAILS
    );
    if (workflow == null) {
        return workflow;
    }
    return workflow;
}

export function setWorkflowTemplateRestoreVersionDetails(details: WorkflowTemplateRestoreVersionDetails): void {
    setObject(RepositoryKey.WORKFLOW_TEMPLATE_RESTORE_VERSION_DETAILS, details);
}

export function clearWorkflowTemplateRestoreVersionDetails(): void {
    remove(RepositoryKey.WORKFLOW_TEMPLATE_RESTORE_VERSION_DETAILS);
}
